// extracted by mini-css-extract-plugin
module.exports = {"video_player_iframe":"VideoPlayer_video_player_iframe__7941X","video_player_container":"VideoPlayer_video_player_container__hTjCo","video_image":"VideoPlayer_video_image__Pc_nO"};